module.exports = __webpack_public_path__ + "img/downloadApp16.ef6f55ee.svg";